<template>
    <div v-show="show" class="bg">
        <div class="box-container">
            <div class="title">
                <p>高级检索</p>
                <img @click="close" src="../../assets/img/common/editPicClose.svg" alt="">
            </div>
            <div class="filter-list">
                <div class="list-container">
                    <p class="title on">添加关键词：</p>
                    <div class="notice-container">
                        <img src="./assets/notify.png" alt="">
                        <p class="notice">同行空格为“且”；新增一组为“或”</p>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in use" :key="index">
                                <input maxlength="150" placeholder="请输入关键词，空格隔开" v-model="item.input" type="text">
                                <img @click="delUse(index)" v-if="index != 0" src="./assets/delIcon.png" alt="">
                            </li>
                        </ul>
                        <div @click="addUse" v-if="use.length < 5" class="btn">
                            <img src="./assets/addIcon.png" alt="">
                            <p>新增一组</p>
                        </div>
                    </div>
                </div>

                <div class="list-container">
                    <p class="title">添加排除词：</p>
                    <div class="notice-container">
                        <img src="./assets/notify.png" alt="">
                        <p class="notice">同行空格为“且”；新增一组为“或”</p>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in except" :key="index">
                                <input maxlength="150" placeholder="请输入关键词，空格隔开" v-model="item.input" type="text">
                                <img @click="delExcept(index)" v-if="index != 0" src="./assets/delIcon.png" alt="">
                            </li>
                        </ul>
                        <div @click="addExcept" v-if="except.length < 5" class="btn">
                            <img src="./assets/addIcon.png" alt="">
                            <p>新增一组</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="btns">
                <p @click="reset" class="btn">重置</p>
                <p @click="search" class="btn green">搜索</p>
            </div>
        </div>
    </div>
</template>

<script>
    import common from "@common/common";
    import { apis } from "@common/config";
    import vClickOutside from "v-click-outside";

    export default {
        directives: {
            clickOutside: vClickOutside.directive
        },
        data() {
            return {
                res: '',
                c: null,
                show: true,
                use: [
                    {input: ''}
                ],
                except: [
                    {input: ''}
                ]
            }
        },
        methods: {
            search() {
                let use = JSON.stringify(this.use)
                let except = JSON.stringify(this.except)

                localStorage.setItem('filterBoxUse', use)
                localStorage.setItem('filterBoxExcept', except)
                let search_keywords = {};
                let inArray = [];
                let outArray = [];
                this.use.forEach(element => {
                    console.log(element)
                    if(element.input){
                        inArray.push(element.input)
                    }
                });
                this.except.forEach(element => {
                    if(element.input){
                        outArray.push(element.input)
                    }
                });
                inArray = inArray.join(',')
                outArray = outArray.join(',')
                search_keywords.in = inArray
                search_keywords.out = outArray
                if(inArray.length > 0){
                    search_keywords = JSON.stringify(search_keywords)
                    console.log(search_keywords)
                    this.c(search_keywords)
                    this.show = false;
                }else{
                    this.$toast('您尚未输入关键词')
                }
            },
            open(res, c) {
                console.log(res)
                this.res = res;
                this.c = c;
                this.show = true;
                if(this.res){
                    let res = this.res
                    res = JSON.parse(res)
                    let use = []
                    let except = []
                    if(res.in.length > 0){
                        res.in.forEach(el => {
                            use.push({
                                input: el.key_words
                            })
                        })
                    }else{
                        use = [
                            {input: ''}
                        ]
                    }
                    
                    if(res.out.length > 0){
                        res.out.forEach(el => {
                            except.push({
                                input: el
                            })
                        })
                    }else{
                        except = [
                            {input: ''}
                        ]
                    }
                    
                    this.use = use
                    this.except = except
                }
            },
            close() {
                this.show = false;
                this.c(false)
            },
            addUse() {
                this.use.push({input: ''})
            },
            addExcept() {
                this.except.push({input: ''})
            },
            delUse(index) {
                this.use.splice(index,1)
            },
            delExcept(index) {
                this.except.splice(index,1)
            },
            reset() {
                this.use = [
                    {input: ''}
                ]
                this.except = [
                    {input: ''}
                ]

                let use = JSON.stringify(this.use)
                let except = JSON.stringify(this.except)

                localStorage.setItem('filterBoxUse', use)
                localStorage.setItem('filterBoxExcept', except)
            }
        },
        mounted() {
            
            // let filterBoxUse = localStorage.getItem('filterBoxUse')
            // let filterBoxExcept = localStorage.getItem('filterBoxExcept')
            // if(filterBoxUse){
            //     this.use = JSON.parse(filterBoxUse)
            // }

            // if(filterBoxExcept){
            //     this.except = JSON.parse(filterBoxExcept)
            // }
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1008;

    .box-container {
        width: 880px;
        padding: 20px 30px 40px;
        background: #F9F9F9;
        border-radius: 4px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
        box-sizing: border-box;

        &>.title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 50px;

            p {
                font-size: 24px;
                color: #050F0F;
                line-height: 33px;
                font-weight: bold;
            }
        }

        .filter-list {
            display: flex;
            flex-direction: column;
            align-items: center;
            max-height: 350px;
            overflow-y: auto;
            margin-bottom: 40px;

            &::-webkit-scrollbar {
                width: 4px;
            }
            &::-webkit-scrollbar-thumb {
                background: #ddd;
                border-radius: 4px;
            }

            .list-container {
                display: flex;
                flex-direction: row;
                margin-bottom: 40px;

                &:nth-last-of-type(1) {
                    margin-bottom: 0;
                }

                .title {
                    position: relative;
                    font-size: 14px;
                    font-weight: bold;
                    color: #829191;
                    line-height: 20px;
                    margin-top: 10px;

                    &.on {
                        &:after {
                            position: absolute;
                            top: 0;
                            left: -16px;
                            display: block;
                            content: '*';
                            font-size: 20px;
                            color: #FF555A;
                        }
                    }
                }

                .notice-container {
                    position: relative;

                    &:hover {
                        .notice {
                            display: block;
                        }
                    }

                    .notice {
                        display: none;
                        position: absolute;
                        top: 40px;
                        left: -20px;
                        height: 30px;
                        line-height: 30px;
                        padding: 0 12px;
                        box-sizing: border-box;
                        border-radius: 4px;
                        background: rgba(30,39,34,0.89);
                        font-size: 12px;
                        color: #FFF;
                        width: max-content;
                    }
                }

                img {
                    width: 16px;
                    height: 16px;
                    margin-top: 12px;
                    margin-right: 14px;
                    user-select: none;
                    cursor: pointer;
                }
                
                .list {
                    display: flex;
                    flex-direction: column;
                    width: 428px;

                    ul {
                        display: flex;
                        flex-direction: column;

                        li {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            width: 100%;
                            height: 40px;
                            background: rgba(185, 195, 195, 0.2);
                            border-radius: 4px;
                            margin-bottom: 14px;
                            padding: 0 15px 0 20px;
                            box-sizing: border-box;

                            input {
                                flex: 1;
                                height: 40px;
                                background: transparent;
                                font-weight: bold;

                                &::placeholder {
                                    font-weight: bold;
                                    color: #B9C3C3;
                                }
                            }

                            img {
                                width: 12px;
                                height: 12px;
                                margin: 0 0 0 10px;
                                user-select: none;
                                cursor: pointer;
                            }
                        }
                    }

                    .btn {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        width: 112px;
                        height: 30px;
                        background: rgba(65, 180, 140, 0.15);
                        border-radius: 4px;
                        border: 1px solid rgba(65, 180, 140, 0.4);
                        user-select: none;
                        cursor: pointer;

                        img {
                            width: 14px;
                            height: 14px;
                            margin: 0;
                        }

                        p {                          
                            color: #41B48C;
                            font-weight: bold;
                            font-size: 14px;
                            margin-left: 9px;
                        }
                    }
                }
            }
        }

        .btns {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .btn {
                width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 25px;
                border: 1px solid #41B48C;
                font-size: 14px;
                font-weight: bold;
                color: #41B48C;
                user-select: none;
                cursor: pointer;

                &.green {
                    margin-left: 20px;
                    color: #FFF;
                    background: #41B48C;
                }
            }
        }
    }
}
</style>